var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    transform: "translate(-21281 -17572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 30,
    height: 30,
    transform: "translate(21281 17572)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "warning_2_",
    "data-name": "warning (2)",
    transform: "translate(21283 17560.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(0 14.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    "data-name": "Path 3198",
    d: "M24.939,33.123l-9-16.538a3.731,3.731,0,0,0-6.417,0l-9,16.538a3.729,3.729,0,0,0,3.208,5.635H21.731A3.73,3.73,0,0,0,24.939,33.123Zm-12.2,2.651a1.492,1.492,0,1,1,1.492-1.492A1.494,1.494,0,0,1,12.734,35.774Zm1.492-5.969a1.492,1.492,0,1,1-2.985,0V22.344a1.492,1.492,0,1,1,2.985,0Z",
    transform: "translate(0 -14.759)",
    fill: "#ffa330"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9ced55ab23e4fab5f829e8371145ebf7.svg";
export { ForwardRef as ReactComponent };